import { useLocation } from "react-router-dom";
import { useAppUpdate } from "../../../shared/lib/app-version";

/**
 * Runs the deploy watcher for the whole app. Headless: the reload it drives happens on navigation,
 * where there is nothing to show. It lives in the app layer because it needs the router (for the
 * pathname the watcher uses as its "has the user moved on yet" signal) and the query client (for
 * mutations in flight).
 */
export function AppUpdater() {
  const { pathname } = useLocation();
  useAppUpdate(pathname);
  return null;
}
